import React, { useEffect, useState } from "react";
import { Table, Pagination, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetCategoryListQuery, useDeleteCategoryMutation, useUpdateCategoryStatusMutation } from "../../Services/CategoryAPI"
import Switch from "react-switch";

function Products() {
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const { data, error, isLoading, refetch } = useGetCategoryListQuery();
    const [deleteBrand] = useDeleteCategoryMutation();
    const [UpdateCategoryStatus] = useUpdateCategoryStatusMutation();

    useEffect(() => {
        refetch();
    }, [refetch])

    // Filter data based on search term
    const filteredData = data?.data?.filter((item) =>
        Object.values(item).some((value) =>
            value !== null && value !== undefined && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );


    // Pagination logic
    const totalPages = Math.ceil(filteredData?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };



    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this Category?");
        if (!confirmDelete) return;

        try {
            await deleteBrand(id).unwrap();  // Call delete API
            alert("Category  deleted successfully!");
            refetch();  // Refresh the list after deletion
        } catch (error) {
            console.error("Error deleting brand:", error);
            alert("Failed to delete Category. Please try again.");
        }
    };

    const handleStatusChange = async (id, newStatus) => {
        try {
            const formData = new FormData();
            formData.append("id", id);
            formData.append("status", newStatus);

            const response = await UpdateCategoryStatus(formData);
            console.log("response", response);
            refetch();
        } catch (error) {
            console.error("Error updating category status:", error);
        }
    };



    if (isLoading) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Categories</h3>
            <div className="content-wrapper">
                <div>
                    {/* Search Input */}
                    <div className="row justify-flex-end search-box">
                        <div className="col-md-6 col-sm-12 col-lg-6 d-flex justify-end gap-10">
                            <InputGroup className="mb-3">
                                <Form.Control
                                    type="text"
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </InputGroup>
                            <Link to="/add-category"><button className="btn-primary w-100"><FontAwesomeIcon
                                icon={faPlus}
                                className="text-primary mx-2"
                            />Add new</button></Link>
                        </div>

                    </div>


                    {/* Table */}
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Category Name</th>
                                    <th>Category Image</th>
                                    <th>Category Type</th>
                                    <th>Description</th>
                                    <th>Action</th>
                                    <th>Hide/Show</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.category_name}</td>
                                        <td>
                                            <img src={item.category_image_url} width={50} height={50} alt="img" />
                                        </td>
                                        <td>{item.parent_id === 0 ? "Main Category" : "Sub category"}</td>
                                        <td>
                                            {item.description.length > 100
                                                ? item.description.substring(0, 100) + "..."
                                                : item.description}
                                        </td>

                                        <td>
                                            {/* <Link to={`/view-category/${item.id}`}>
                                                <FontAwesomeIcon icon={faEye} className="mx-2" style={{ cursor: "pointer" }} />
                                            </Link> */}
                                            <Link to={`/edit-category/${item.id}`}>
                                                <FontAwesomeIcon icon={faEdit} className="text-warning mx-2" style={{ cursor: "pointer" }} />
                                            </Link>
                                            <FontAwesomeIcon
                                                icon={faTrash}
                                                className="text-danger mx-2"
                                                onClick={() => handleDelete(item.id)}
                                                style={{ cursor: "pointer" }}
                                            />
                                        </td>
                                        <td>
                                            <Switch
                                                onChange={() => handleStatusChange(item.id, item.status === 1 ? 0 : 1)}
                                                checked={item.status === 1}
                                                onColor="#4CAF50"
                                                offColor="#ccc"
                                                checkedIcon={false}
                                                uncheckedIcon={false}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>


                    {/* Pagination */}
                    <Pagination className="d-flex justify-flex-end">
                        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                        {[...Array(totalPages)].map((_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => handlePageChange(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                    </Pagination>
                </div>
            </div>
        </div>
    );
}

export default Products;
